"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationInstanceLetterStatus;
(function (CommunicationInstanceLetterStatus) {
    CommunicationInstanceLetterStatus["Created"] = "Created";
    CommunicationInstanceLetterStatus["Processed"] = "Processed";
    CommunicationInstanceLetterStatus["ProcessError"] = "ProcessError";
    CommunicationInstanceLetterStatus["Queued"] = "Queued";
    CommunicationInstanceLetterStatus["QueueError"] = "QueueError";
    CommunicationInstanceLetterStatus["Sent"] = "Sent";
    CommunicationInstanceLetterStatus["SendError"] = "SendError";
    CommunicationInstanceLetterStatus["Mailed"] = "Mailed";
    CommunicationInstanceLetterStatus["InLocalArea"] = "In Local Area";
    CommunicationInstanceLetterStatus["InTransit"] = "In-Transit";
    CommunicationInstanceLetterStatus["OutForDelivery"] = "Out for Delivery";
    CommunicationInstanceLetterStatus["Delivered"] = "Delivered";
    CommunicationInstanceLetterStatus["ReturnedToSender"] = "Returned to Sender";
    CommunicationInstanceLetterStatus["ReRouted"] = "Re-routed";
    CommunicationInstanceLetterStatus["Printed"] = "Printed";
    CommunicationInstanceLetterStatus["Issue"] = "Issue";
    CommunicationInstanceLetterStatus["ProcessedForDelivery"] = "Processed for Delivery";
    CommunicationInstanceLetterStatus["PickupAvailable"] = "Available for Pickup";
})(CommunicationInstanceLetterStatus = exports.CommunicationInstanceLetterStatus || (exports.CommunicationInstanceLetterStatus = {}));
//# sourceMappingURL=CommunicationInstanceLetterStatus.js.map